import { render, staticRenderFns } from "./carousel01.vue?vue&type=template&id=5acc0844"
import script from "./carousel01.vue?vue&type=script&lang=js"
export * from "./carousel01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports